/**
 * Width of the sidebar drawer in pixels
 */
export const DRAWER_WIDTH = 240;
